"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Trust() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const partners = [{
    name: "Leica",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/partner_leica.png"
  }, {
    name: "Kodak",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/partner_kodak.png"
  }, {
    name: "Hasselblad",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/partner_hasselblad.png"
  }, {
    name: "Ilford",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/partner_ilford.png"
  }, {
    name: "PhaseOne",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/partner_phaseone.png"
  }, {
    name: "Fujifilm",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/partner_fujifilm.png"
  }, {
    name: "Zeiss",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/partner_zeiss.png"
  }, {
    name: "Broncolor",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/partner_broncolor.png"
  }, {
    name: "Profoto",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/partner_profoto.png"
  }, {
    name: "Manfrotto",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/partner_manfrotto.png"
  }];
  const loop = [...partners, ...partners];
  return <section data-section-id="4325" id="collector-trust" className="bg-background text-foreground py-[100px] overflow-hidden">
      <style>{`
        @keyframes chroma-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .chroma-marquee-track {
          animation: chroma-marquee 30s linear infinite;
        }
        .chroma-marquee-track:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        {}
        <div className="flex items-center justify-center gap-4 sm:gap-6 px-4 mb-12 sm:mb-16">
          <span className="hidden sm:block h-px bg-foreground/40" style={{
          width: "60px"
        }} aria-hidden="true" />
          <p className="font-mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-foreground/40 text-center">
            Technical Standards
          </p>
          <span className="hidden sm:block h-px bg-foreground/40" style={{
          width: "60px"
        }} aria-hidden="true" />
        </div>

        {}
        <div className="relative w-full">
          {}
          <div className="pointer-events-none absolute left-0 top-0 bottom-0 z-10 w-10" style={{
          background: "linear-gradient(to right, var(--background), transparent)"
        }} aria-hidden="true" />
          {}
          <div className="pointer-events-none absolute right-0 top-0 bottom-0 z-10 w-10" style={{
          background: "linear-gradient(to left, var(--background), transparent)"
        }} aria-hidden="true" />

          <div className="overflow-hidden">
            <div className="chroma-marquee-track flex items-center w-max group">
              {loop.map((partner, i) => <div data-index={i} key={i} className="flex items-center justify-center shrink-0 px-[28px] sm:px-[48px] transition-opacity duration-[400ms] opacity-50 hover:!opacity-100 group-hover:opacity-50">
                  <img src={partner.src} data-wvc-srcset={`${partner.src}-wvc-srcset`} data-wvc-sizes={`${partner.src}-wvc-sizes`} alt={partner.name} loading="lazy" decoding="async" className="h-6 sm:h-8 w-auto object-contain select-none grayscale invert" draggable={false} />
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}